<div normal>
    <modal-default-mmaxapp>
            <div class="tarjetaconfirmar">
                <div class="titulo">
                        Nuestra Empresa
                </div>
                <div class="leyendaconfirmar">
                        {{DataEmpresa}}
                </div>
                <div class="botones">
                        <button class="buttonpc whibutton" (click)="aceptar()">Aceptar</button>
                </div>
            </div>
    </modal-default-mmaxapp>
</div>